import React from 'react';
import { social_media } from '../../../../../utils';
import { useTranslation } from 'react-i18next';

import { IconList, MainDiv, StyledTypography, Icon } from './styles';

const SocialMedia = () => {
	const { t } = useTranslation();

	const getItems = () => {
		return social_media.map((item, idx) => (
			<a href={item.link} target="_blank" rel="noopener noreferrer">
				<Icon src={item.icon} />
			</a>
		));
	};

	return (
		<MainDiv>
			<StyledTypography variant="h4">{t('general.contact.follow')}</StyledTypography>
			<IconList>{getItems()}</IconList>
		</MainDiv>
	);
};

export default SocialMedia;
